
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"12.323","height":"1.396","rx":".698","transform":"matrix(.82373 -.56699 .58017 .8145 .051 6.987)","fill":"#295E60"}}),_c('rect',{attrs:{"x":".301","y":"6.575","width":"14.918","height":"1.364","rx":".682","fill":"#295E60"}}),_c('rect',{attrs:{"x":"19.903","y":"6.575","width":"11.34","height":"1.388","rx":".694","transform":"rotate(90 19.903 6.575)","fill":"#295E60"}}),_c('path',{attrs:{"d":"M.388 17.318c0-.377.305-.682.682-.682h18.15a.682.682 0 010 1.364H1.07a.682.682 0 01-.682-.682z","fill":"#295E60"}}),_c('path',{attrs:{"d":"M1.038 17.915a.65.65 0 01-.65-.65v-7.226a.65.65 0 011.3 0v7.225a.65.65 0 01-.65.65zm4.337-2.558a.65.65 0 01-.65-.65v-4.668a.65.65 0 111.3 0v4.667a.65.65 0 01-.65.65zm4.51 0a.65.65 0 01-.65-.65v-4.668a.65.65 0 111.3 0v4.667a.65.65 0 01-.65.65zm4.511 0a.65.65 0 01-.65-.65v-4.668a.65.65 0 111.3 0v4.667a.65.65 0 01-.65.65z","fill":"#295E60"}}),_c('rect',{attrs:{"width":"12.273","height":"1.396","rx":".698","transform":"matrix(.82373 .56699 -.58017 .8145 10.015 .119)","fill":"#295E60"}})])
          )
        }
      }
    